import * as yup from 'yup'

const appTypeSchema = yup.object().shape({
  appType: yup.string().oneOf(['superapp', 'ibul']).nullable()
})

export const validateAppType = async (appType: string | null) => {
  return (await appTypeSchema.validate({ appType })).appType
}
